import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { device, Dialog as DialogCmp } from '@landsbankinn/ui';
import React, { useState } from 'react';

interface IProps {
  title: Prismic.RichText;
  content: Prismic.RichText;
  open_on_load?: boolean;
}

const res = {
  declineUrl: {
    is: 'https://www.landsbankinn.is',
    en: 'https://www.landsbankinn.com',
  },
  text: {
    is: 'Ég samþykki',
    en: 'I aggree',
  },
  declineText: {
    is: 'Ég samþykki ekki',
    en: `I don't agree`,
  },
};

const Title = styled.h2`
  font-family: ${(props) => props.theme.font.familySerifCond};
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0.23px;
  line-height: 36px;
  margin-top: 65px;
  margin-bottom: 50px;
  @media ${device.tablet} {
    text-align: center;
  }
`;
const Content = styled.div`
  p {
    font-family: ${(props) => props.theme.font.family};
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0.22px;
    margin-bottom: 26px;
  }
  strong {
    font-family: ${(props) => props.theme.font.family};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.22px;
    margin-bottom: 26px;
    margin-top: 9px;
    display: inline-block;
  }
`;

const ConfirmButtonContainer = styled.div`
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  padding: 18px 20px 41px 20px;
  width: 100%;
  height: 123px;
  background: rgba(255, 255, 255, 0.97);
  justify-content: space-between;
  box-shadow: 0px -4px 12px 0px rgba(67, 76, 90, 0.15);

  @media ${device.desktop} {
    justify-content: center;
    left: 130px;
    max-width: calc(100vw - 260px);
  }
`;

const ConfirmButton = styled.button<{ noBackground?: boolean }>`
  height: 64px;
  padding-top: 20px;
  padding-bottom: 25px;
  min-width: 180px;
  border: 1px solid rgb(27, 60, 88);
  background: ${(props) => (props.noBackground ? 'white' : 'rgb(27, 61, 89);')};
  color: ${(props) => (props.noBackground ? 'rgb(27, 61, 89)' : 'white')};
  font-weight: 500;
  font-size: 16px;
  &:hover {
    cursor: pointer;
  }
  @media ${device.tablet} {
    margin: 0 10px;
    min-width: 300px;
    font-size: 18px;
  }
  @media ${device.desktop} {
    min-width: 380px;
  }
`;

export function TermsDialogContainer({ title, content, open_on_load }: IProps) {
  const [isOpen, setIsopen] = useState(open_on_load);
  const { r } = useResource();

  return (
    <>
      {isOpen && (
        <DialogCmp title={{ label: Prismic.text(title) ?? '', hidden: true }}>
          <Title>{Prismic.text(title)}</Title>
          <Content>
            <PrismicText value={content} />
          </Content>
          <ConfirmButtonContainer>
            <ConfirmButton
              noBackground
              onClick={() => {
                window.location.href = r(res.declineUrl);
              }}
            >
              {r(res.declineText)}
            </ConfirmButton>
            <ConfirmButton onClick={() => setIsopen(!isOpen)}>
              {r(res.text)}
            </ConfirmButton>
          </ConfirmButtonContainer>
        </DialogCmp>
      )}
    </>
  );
}
